<template>
  <!--  字段解析器-->
  <div>


    <!--    输入框-->
    <div v-if="temp.type=='input'">

      <el-input v-model="temp.value" :maxlength="temp.maxlength||20" :placeholder="'请输入'+temp.name" clearable>
        <template slot="prepend" v-if="temp.prefix">{{ temp.prefix }}</template>
        <template slot="append" v-if="temp.suffix">{{ temp.suffix }}</template>
      </el-input>
    </div>

    <!--    密码-->
    <div v-if="temp.type=='password'">
      <el-input type="password" :maxlength="Number(temp.maxlength)||20" v-model="temp.value" :placeholder="'请输入'+temp.name" clearable>

        <template slot="prepend" v-if="temp.prefix">{{ temp.prefix }}</template>
        <template slot="append" v-if="temp.suffix">{{ temp.suffix }}</template>
      </el-input>
    </div>


    <!--    数字-->
    <div v-if="temp.type=='number'">
      <el-input type="number" v-model.number="temp.value" :placeholder="'请输入'+temp.name" clearable>
        <template slot="prepend" v-if="temp.prefix">{{ temp.prefix }}</template>
        <template slot="append" v-if="temp.suffix">{{ temp.suffix }}</template>
      </el-input>
    </div>


    <!--    多行-->
    <div v-if="temp.type=='textarea'">
      <el-input type="textarea" :show-word-limit="true" v-model="temp.value" :placeholder="'请输入'+temp.name">
      </el-input>
    </div>

    <!--    时间-->
    <div v-if="temp.type=='time'">

      <el-time-picker style="width: 100%" value-format="timestamp" v-if="temp.is_range" is-range v-model="temp.value" placeholder="请选择"></el-time-picker>
      <el-time-picker style="width: 100%" value-format="timestamp" v-else v-model="temp.value" placeholder="请选择"></el-time-picker>

    </div>
    <!--    日期-->
    <div v-if="temp.type=='date'">

      <el-date-picker style="width: 100%" value-format="timestamp" v-if="temp.is_range" type="daterange" v-model="temp.value"
                      placeholder="请选择"></el-date-picker>
      <el-date-picker style="width: 100%" value-format="timestamp" v-else v-model="temp.value" placeholder="请选择"></el-date-picker>

    </div>

    <!--    时间日期-->
    <div v-if="temp.type=='datetime'">

      <el-date-picker style="width: 100%" value-format="timestamp" v-if="temp.is_range" type="datetimerange" v-model="temp.value"
                      placeholder="请选择"></el-date-picker>
      <el-date-picker style="width: 100%" value-format="timestamp" v-else v-model="temp.value" type="datetime" placeholder="请选择"></el-date-picker>

    </div>

    <!--    image-->
    <div v-if="temp.type=='image'">
      <upload type="img" ref="images" :max="Number(temp.uploadnum)" :values="temp.value" @upload="uploadimg(temp,$event)"></upload>

    </div>
<!--    &lt;!&ndash;    image&ndash;&gt;-->
<!--    <div v-if="temp.type=='imagejinjiang'">-->
<!--      <uploadjin type="img" ref="images" :max="Number(temp.uploadnum)" :values="temp.value" @upload="temp.value=$event"></uploadjin>-->

<!--    </div>-->

    <!--    file-->
    <div v-if="temp.type=='file'">

      <upload type="file" ref="file" :max="Number(temp.uploadnum)" :values="temp.value"  @upload="uploadimg(temp,$event)"></upload>

    </div>
    <!--    user-->
    <div v-if="temp.type=='user'">

      <select_user :values="temp.value" @select="temp.value=$event" :mode="temp.usermode"></select_user>

    </div>


    <!--    department-->
    <div v-if="temp.type=='department'">
      <select_department :values="temp.value?temp.value:''" @sure="temp.value=$event" :type="temp.usermode?temp.usermode:''"></select_department>
    </div>

    <!--    map-->
    <div v-if="temp.type=='address'">
      <selectmap :values="temp.value" @selectmap="temp.value=$event"></selectmap>
    </div>

    <!--    map-->
    <div v-if="temp.type=='activityselect'">
      <selectdata :keyname="temp.key" :values="temp.value" :ref="temp.key" @select="temp.value= $event"></selectdata>
    </div>

    <!--    下拉选-->
    <div v-if="temp.type=='select'">
      <el-select v-model="temp.value" clearable filterable placeholder="请选择">
        <el-option
          v-for="item in temp.selectdata"
          :key="item.value"
          :label="item.label"
          :value="{value:item.value,label:item.label}">
        </el-option>
      </el-select>


    </div>

    <!--    多选-->
    <div v-if="temp.type=='checkbox'">


      <el-checkbox-group v-model="temp.value">

        <el-checkbox v-for="(item,index) in temp.selectdata" :label="item" :key="index"></el-checkbox>

      </el-checkbox-group>

    </div>

    <!--    单选-->
    <div v-if="temp.type=='radio'">

      <el-radio v-for="(item,index) in temp.selectdata" v-model="temp.value" :label="item" :key="index">{{ item }}</el-radio>

    </div>
    <!--    code-->
    <div v-if="temp.type=='code'">

      <el-input v-model="temp.value" disabled clearable></el-input>

    </div>
    <!--    数据选择-->
    <div v-if="temp.type=='dataselect'">

      <dataselect :ref="temp.type" :field="field" @selectchange="selectchange(temp,$event)" :oem="oem" :temp="temp"></dataselect>

    </div>
    <!--    数据选择-->
    <div v-if="temp.type=='association'">

      {{ temp.value ? temp.value.toString() : '' }}

    </div>

  </div>
</template>

<script>
import upload from "../util/upload"
import select_user from "../util/selectuser"
import selectmap from "../util/select_map"
import select_department from "./select_department";
import selectdata from "../util/selectdata" //动态下拉选
import dataselect from "./dataselect";
import util from "../../../assets/js/util"; //关联下拉选

// import uploadjin from "../util/uploadjin"

export default {
  components: {
    upload,
    // uploadjin,
    select_user,
    selectmap,
    selectdata,
    dataselect,
    select_department,
  }
  ,
  props: ["temp", "field", "isedit", "oem"],
  name: "parser",
  mounted() {
    if (this.temp.type == 'code') {
      this.temp.value = util.formatDateTime(7)
    }


  },
  methods: {
    reloadview(){

      this.$refs.images.updateinof()
      this.$refs.file.updateinof()
    },
    uploadimg(e, value) {
      e.value = value
      this.$emit("uploadImgage", e, value)

    },
    updateinof(e) {
      this.$refs.images.updateinof()

    },
    updateinoffile() {
      this.$refs.file.updateinof()
    },
    //自定义事件 可以返回到最上层做自定义处理
    selectchange(temp, e) {
      temp.value = e
      this.$emit("parserevent", temp)
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/page/module/util/parser.vue